import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-flujo-credito-light-modal-consolidado',
    templateUrl: './flujo-credito-light-modal-consolidado.component.html',
    styleUrls: ['./flujo-credito-light-modal-consolidado.component.scss']
})
export class FlujoCreditoLightModalConsolidadoComponent {
    rut = '';
    idTransaccion = '';
    dataServicios: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.rut = data.rut;
        this.idTransaccion = data.idTransaccion;
        this.dataServicios = data.dataServicios;
    }
}
